import { Flex } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = ({ t }) => {
  return (
    <Flex className={styles['head__container']}>
      <TextBold className={styles['title__text']}>{t('title')}</TextBold>
    </Flex>
  );
};

export default Head;
